import { render, staticRenderFns } from "./SurfaceAutoType.vue?vue&type=template&id=210971c0&scoped=true&"
import script from "./SurfaceAutoType.vue?vue&type=script&lang=js&"
export * from "./SurfaceAutoType.vue?vue&type=script&lang=js&"
import style0 from "./SurfaceAutoType.vue?vue&type=style&index=0&id=210971c0&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "210971c0",
  null
  
)

export default component.exports